module.exports = __webpack_public_path__ + "static/img/logo.d35400a.png";